export default "__VITE_ASSET__C8Jr4FF9__"